import { render, staticRenderFns } from "./MainScreenActionsBar.vue?vue&type=template&id=1e12e1eb&scoped=true&"
import script from "./MainScreenActionsBar.vue?vue&type=script&lang=js&"
export * from "./MainScreenActionsBar.vue?vue&type=script&lang=js&"
import style0 from "./MainScreenActionsBar.vue?vue&type=style&index=0&id=1e12e1eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e12e1eb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3547940844/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e12e1eb')) {
      api.createRecord('1e12e1eb', component.options)
    } else {
      api.reload('1e12e1eb', component.options)
    }
    module.hot.accept("./MainScreenActionsBar.vue?vue&type=template&id=1e12e1eb&scoped=true&", function () {
      api.rerender('1e12e1eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MainScreenActionsBar.vue"
export default component.exports